import React from 'react';
import { gray4, white } from '@engage/colors';

type Props = {
  title?: string;
  boundingBox?: boolean;
  slate?: boolean;
  id?: string;
};

const TakenCheck: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement> & Props>
> = ({ boundingBox, color, title, id, ...props }) => {
  const titleId = id ? `taken-check-${id}` : 'taken-check';

  return (
    <svg
      width={28}
      height={28}
      viewBox="0 0 28 28"
      role="img"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      {boundingBox ? (
        <rect fillOpacity={0.15} fill={gray4} width={28} height={28} rx={3} />
      ) : null}
      <g transform="translate(1.077 1.077)">
        <path
          d="M9.634 19.673l-5.727-5.997a.698.698 0 0 1 1.007-.963l5.223 5.47L21.086 6.715a.696.696 0 1 1 1.006.963L10.64 19.673a.695.695 0 0 1-1.006 0z"
          fill={color ?? white}
        />
      </g>
    </svg>
  );
};

export default TakenCheck;
